import { render, staticRenderFns } from "./edit-favorites.vue?vue&type=template&id=37c8a390&"
import script from "./edit-favorites.vue?vue&type=script&lang=js&"
export * from "./edit-favorites.vue?vue&type=script&lang=js&"
import style0 from "./edit-favorites.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports